<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="assets"
      class="elevation-1"
      :loading="loading"
      :search="search"
      :no-data-text="$t('noinfo')"
      :no-results-text="$t('no_matching_records_found')"
    >
      <template v-slot:item.action="{ item }">
        <div class="flex justify-end gap-2">
          <v-btn
            color="warning"
            text
            @click="onUpdate(item)"
          >
            <v-icon left>mdi-pencil</v-icon>{{ $t('action_type.edit') }}
          </v-btn>
          <v-btn
            color="error"
            text
            @click="onRemove(item)"
          >
            <v-icon left>mdi-trash-can</v-icon>{{ $t('action_type.delete') }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      assets: "asset/getAssets",
    }),
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('asset.asset_name'),
          value: "name",
        },
        {
          text: this.$t('asset.asset_name_en'),
          value: "name_en",
        },
        {
          text: this.$t('asset.category'),
          value: "categoryName",
        },
        {
          text: "",
          value: "action",
        },
      ],
    };
  },
  methods: {
    onUpdate(item) {
      this.$emit("onUpdate", item);
    },
    onRemove(item) {
      this.$emit("onRemove", item);
    },
  },
  props: {
    search: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>